// extracted by mini-css-extract-plugin
module.exports = {"tokenWrapper":"cn_tokenWrapper__2czHJ","tokenName":"cn_tokenName__mSXEc","tokenIcon":"cn_tokenIcon__2uxEe"};